import { createSelector } from 'reselect';
import { IState } from '..';

const meSelector = (state: IState) => state.me.me;

export const getDisplayName = createSelector(meSelector, (me): string => me?.displayName ?? '?');

export const isCurrentUser = createSelector(
  [meSelector, (_: unknown, sid: string) => sid],
  (me, sid): boolean => me?.onPremisesSecurityIdentifier === sid
);

export const getSid = createSelector(meSelector, (me): string => me?.onPremisesSecurityIdentifier ?? '');
